// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiInt from "./LumiInt.res.js";

let Interval = {};

let Locale = {};

function fromSeconds(remSeconds) {
  let match = LumiInt.divMod(remSeconds, 60);
  let match$1 = LumiInt.divMod(match[0], 60);
  let match$2 = LumiInt.divMod(match$1[0], 24);
  let match$3 = LumiInt.divMod(match$2[0], 7);
  return {
    weeks: match$3[0],
    days: match$3[1],
    hours: match$2[1],
    minutes: match$1[1],
    seconds: match[1]
  };
}

let Duration = {
  fromSeconds: fromSeconds
};

let Day = {};

let Formats = {
  dateOnly: "PPP",
  short: "Pp",
  long: "PPPp",
  full: "PPPPp"
};

export {
  Interval,
  Locale,
  Duration,
  Day,
  Formats,
}
/* No side effect */
